import { connect } from 'react-redux'
import { getClientsList } from '../actions/actions-clients'
import { getProgramsAssignedToLoginList } from '../actions/actions-programs'
import Clients from '../views/Clients/clients'
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    clients: state.clientsR.dataList,
    programsAssigned: state.programsR.programsassignedtologin,
  }
}
const mapDispatchToProps = dispatch => {
  return {
    getClients: loginID => {
      dispatch(getClientsList(loginID))
    },
    getProgramsAssignedToLoginList: id => {
      dispatch(getProgramsAssignedToLoginList(id))
    }
  }
}
const ClientListContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Clients)
export default ClientListContainer
